import { File_Audience } from "@qw/graphql";
import { FieldSelect } from "@qw/ui";
import { z } from "zod";

export const audienceSchema = z.object({ audience: z.nativeEnum(File_Audience) });

const options = [
  { value: File_Audience.Internal, label: "Internal users only" },
  { value: File_Audience.External, label: "All users" },
];

export const AudienceField = () => <FieldSelect name="audience" placeholder="Audience" options={options} />;
